import { Argument } from '../argument.model';
import { AverageRanking } from '../averageRanking/averageRanking.model';
import { Ranking } from '../ranking/ranking.model';
import { Softskill } from '../softskill/softskill.model';

export class SalesPackage {
    id: string;
    name: string;
    readableName: string;
    description: string;
    descriptionShort: string;
    type: string;
    typeToShow: string;
    price: number;
    duration: number;
    averageValue: number;
    ranking?: AverageRanking;
    frontEndSoftskillFacade: Softskill;
    imageUrl: string;
    imageMiniUrl: string;
    color: string;
    arguments: Array<Argument>;
    rankings: Array<Ranking>;
    averageRanking: number;
}